import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { usePostCustomerData } from "../../hooks";

import {
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormWrapper,
} from "../../components";
import CreateCompanyForm from "./CreateCompanyForm";
import { useDialogContext } from "../HubDialogWrapper";

const CreateCompanyContent = ({ isVendor = false }) => {
  const navigate = useNavigate();
  const {
    mutate: postCustomerData,
    isLoading,
    isSuccess,
    data,
  } = usePostCustomerData();

  const { onClose = () => {} } = useDialogContext();

  useEffect(() => {
    if (isSuccess && data?.id) {
      onClose();
      navigate(`/customers/${data?.id}`);
    }
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const locations = formData.locations?.map((l) => l.id);
    const payload = {
      name: formData.customerName,
      industryId: formData?.industry,
      isVendor,
      ranking: formData?.ranking || 1,
      active: true,
      locations,
      contacts: [
        {
          name: formData.contactName,
          cellNumber: formData.phone,
          email: formData.email,
        },
      ],
    };
    postCustomerData(payload);
  };

  return (
    <HubDialogContent largePadding>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="35px">
          <Stack gap="10px" alignItems="center">
            <Typography variant="h6">
              Create a New {isVendor ? "Vendor" : "Customer"}
            </Typography>
            <Typography
              variant="caption"
              sx={{ textAlign: "center", maxWidth: "450px" }}
            >
              {isVendor
                ? "Use the fields below to create a new vendor"
                : "Creating a new customer will start the quoting process"}
            </Typography>
          </Stack>
          <CreateCompanyForm disabled={isLoading} isVendor={isVendor} />
          <HubCancelSubmitGroup
            disabled={isLoading}
            isLoading={isLoading}
            label={isVendor ? "Create Vendor" : "Create Customer"}
          />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default CreateCompanyContent;
